import { DEFAULT_PAGINATION_LIMIT } from "../../../../../../globalConstants";

const STRINGS = {
  COLUMN_HEADER: {
    1: "Day of the Week",
    2: "Hours of Operation",
  },
  BUTTON_LABELS: {
    ADD_NEW_WINDOW: "Add new time window",
    CANCEL: "Cancel",
    SAVE: "Save",
  },
  HEADERS: {
    AVAILABLE_SERVICES: "Available Services",
    PROVIDED_SERVICES: "Provided Services",
    SELECT_ALL: "Select All",
  },
  SERVICE_TYPE: {
    AVAILABLE: "A",
    PROVIDED: "P",
  },
  NETWORK_STATUS_TYPE: {
    true: "In Network",
    false: "Out of Network",
  },
  MODE: {
    ADD: "A",
    EDIT: "E",
    DELETE: "D",
  },
  NO_TIME_WINDOW: "No time slots",
  ADD_TIME_SLOT: "Please add a time window",
  DEFAULT_PAGE: 1,
  DEFAULT_PAGINATION_LIMIT: DEFAULT_PAGINATION_LIMIT,
  DEFAULT_PROVIDED_SERVICES_PAGINATION_LIMIT: 100,
  NO_SERVICE_DESCRIPTION: "No Description",
  SEARCH_SERVICES_PLACEHOLDER: "Search Services",
  DAYS_IN_WEEK: 7,
  NOTHING_TO_SHOW: "Nothing to Show",
};
export default STRINGS;
